import { mailIcon, phoneIcon } from '@/images'
import { formatPhoneNumber } from '@/utils'
import { GxIcon } from '@garpix/garpix-web-components-react'
import classNames from 'classnames'
import React from 'react'
import style from './styles/leaders.module.scss'

interface IProps {
  photo: string
  name: string
  position: string
  phone: string
  additionalPhone: string | null
  email: string
  className?: string
}

const LeadersCard = ({
  photo,
  name,
  position,
  phone,
  additionalPhone,
  email,
  className = ''
}: IProps): React.ReactElement => {
  let phoneLink = phone
  if (additionalPhone !== null) {
    phoneLink += `p${additionalPhone}`
  }

  return (
    <div
      className={classNames({
        [style.leaders]: true,
        [className]: Boolean(className)
      })}
    >
      <div className={style.leaders_top}>
        <img
          src={photo}
          width='150px'
          height='150px'
          alt={name}
          className={style.leaders__photo}
        />
        <div>
          <span className={style.leaders__name}>{name}</span>
          <span className={style.leaders__position}>{position}</span>
        </div>
      </div>
      <div className={style.leaders_links}>
        <a href={`tel:${phoneLink}`} className={style.leaders__link}>
          <GxIcon src={phoneIcon} className={style.leaders__icon} />
          <div>
            <span className={style.leaders__link_text}>
              {formatPhoneNumber(phone)}
            </span>
            {additionalPhone !== null
              ? (
                <span className={style.leaders__link_subtext}>
                  {`(добавочный - ${additionalPhone})`}
                </span>
                )
              : undefined}
          </div>
        </a>
        <a href={`mailto:${email}`} className={style.leaders__link}>
          <GxIcon src={mailIcon} className={style.leaders__icon} />
          <span className={style.leaders__link_text}>{email}</span>
        </a>
      </div>
    </div>
  )
}

export default LeadersCard
